export default "__VITE_ASSET__CiUfXODQ__"